import { render, staticRenderFns } from "./AssinaturasPonto.vue?vue&type=template&id=36854b36"
import script from "./AssinaturasPonto.vue?vue&type=script&lang=js"
export * from "./AssinaturasPonto.vue?vue&type=script&lang=js"
import style0 from "./AssinaturasPonto.vue?vue&type=style&index=0&id=36854b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports